import { create } from 'zustand';

type CustomAddressDrawerState = {
    isOpen: boolean;
    open: () => void;
    close: () => void;
};

export const useCustomAddressDrawerStore = create<CustomAddressDrawerState>()(set => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
}));
